module.exports = __webpack_public_path__ + "static/media/sygnet.2122fc3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/sygnet.svg
// module id = 936
// module chunks = 31